import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core'
import { Router } from '@angular/router'
import { Clicks } from '@shared/directives'
import { Tab } from '@shared/models'

@Component({
  selector: 'tabs',
  imports: [Clicks],
  templateUrl: './tabs.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Tabs {
  #router = inject(Router)

  activeTab = model<string>()
  tabs = input.required<Tab[]>()
  clicksPrefix = input<string>('')

  selectTab(tab: Tab) {
    if (tab.redirect) {
      this.#router.navigateByUrl(tab.redirect)
      return
    }

    this.activeTab.set(tab.value)
  }
}
